module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPHBhdGggZmlsbD0iIzAwNmE0ZSIgZD0iTTAgMGg2NDB2NDgwSDB6Ii8+CiAgPGNpcmNsZSBjeD0iMjgwIiBjeT0iMjQwIiByPSIxNjAiIGZpbGw9IiNmNDJhNDEiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/bd.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/bd.svg
// module chunks = 0